export interface MasterPlanLocationFilterWebEntity {
  id: string;
  filterValue: string;
  filterTypeId: string;
  filterFieldId: string;
  planContainerId: string;
  sequenceNumber: number;

  }